import React from "react";
import styled from "styled-components";

import instagram from "../img/instagram.png";
import youtube from "../img/youtube.png";

const SocialBar = styled.div`
  position: fixed;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;

  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (max-width: 768px) {
    left: 12px;
    gap: 10px;
  }
`;

const SocialButton = styled.a`
  width: 64px;
  height: 64px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(15, 15, 15, 0.92);
  backdrop-filter: blur(12px);

  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;

  box-shadow:
    0 10px 30px rgba(0,0,0,0.35),
    0 0 20px rgba(255,0,0,0.12);

  transition: all 0.35s ease;

  &:hover {
    transform: translateX(6px) scale(1.08);

    box-shadow:
      0 15px 35px rgba(0,0,0,0.45),
      0 0 35px rgba(255,0,0,0.4);

    border-color: rgba(255,0,0,0.5);
  }

  img {
    width: 34px;
    height: 34px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;

    img {
      width: 28px;
      height: 28px;
    }
  }
`;

export function Icons() {
  return (
    <SocialBar>
      <SocialButton
        href="https://www.instagram.com/teamohanamma/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <img src={instagram} alt="Instagram" />
      </SocialButton>


    </SocialBar>
  );
}